import { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface ContentCardProps {
  children: ReactNode
  className?: string
  minHeight?: string | number
}

interface ContentCardHeaderProps {
  title: string
  actions?: ReactNode
  className?: string
}

interface ContentCardBodyProps {
  children: ReactNode
  className?: string
  scrollHeight?: string | number
}

function ContentCardRoot({
  children,
  className,
  minHeight = '20rem',
}: ContentCardProps) {
  return (
    <div
      className={cn(
        'flex flex-col gap-4 rounded-xl border bg-[#FAFAFA] p-2 shadow-sm sm:p-4',
        className
      )}
      style={{ minHeight }}
    >
      {children}
    </div>
  )
}

function ContentCardHeader({
  title,
  actions,
  className,
}: ContentCardHeaderProps) {
  return (
    <div className={cn('flex flex-col gap-3', className)}>
      <h3 className="font-geist text-base font-medium leading-6 text-[#262626]">
        {title}
      </h3>
      {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
    </div>
  )
}

function ContentCardBody({
  children,
  className,
  scrollHeight = '13rem',
}: ContentCardBodyProps) {
  return (
    <div
      className={cn(
        'overflow-x-auto overflow-y-auto rounded border border-gray-300',
        className
      )}
      style={{ height: scrollHeight }}
    >
      {children}
    </div>
  )
}

export const ContentCard = Object.assign(ContentCardRoot, {
  Header: ContentCardHeader,
  Body: ContentCardBody,
})
